import { render, staticRenderFns } from "./TextTemplateForm.vue?vue&type=template&id=320641f6&"
import script from "./TextTemplateForm.vue?vue&type=script&lang=js&"
export * from "./TextTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports